import { render } from "./IdentityManagerForm.vue?vue&type=template&id=3f7520e4"
import script from "./IdentityManagerForm.vue?vue&type=script&lang=js"
export * from "./IdentityManagerForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__